var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"83px"}},[_c('div',{staticClass:"TSDN-title"},[_vm._v("关于亚马逊SHIPTRACK")]),_c('div',{staticClass:"TSDN-content"},[_vm._v(" 为了帮助广大的中国卖家在亚马逊平台更好地经营，亚马逊在2023年8月底针对中国卖家发出了一条公告，可以为中国卖家的FBA货件提供更加精准的物流追踪服务，对于没有使用官方合作承运商的中国FBA卖家，可以考虑选择参与ShipTrack计划的承运商，这些承运商会自动在卖家中心更新点对点的物流追踪信息。 ")])])])
}]

export { render, staticRenderFns }